import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TableRow,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import { Typography, Grid } from "@material-ui/core";
import DataTableRow from "./DataTableRow";
import Scroll from "../../../components/scroll/Scroll"
import TableEmptyState from "../../common/TableEmptyState";
import { placeOrdersAction, basketAction, getMarginAction } from "../../../redux/actions/brokerAction";
import { useDispatch, useSelector } from "react-redux";
import { generateUniqueId } from "../../../util/helper";

// style constant
const useStyles = makeStyles((theme) => ({
  heading: {
    color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
    fontWeight: "bold",
    padding: "2px 0px",
    fontFamily: "poppins",
    background: ({ isDark }) => (isDark ? "#0b1727" : "#edf2f9"),
  },

  headingCol: {
    padding: "1px 2px !important",
    fontSize: "0.7rem",
    color: "#fff",
    background: "#1c99ed",
    border: "#1px solid #ffffff",
    fontWeight: "bold",
    fontFamily: "poppins",
    borderBottom: "none",

  },
  colh: {
    padding: "1px 2px !important",
    border: "#1px solid #ffffff",
    borderBottom: "none",
  },
  tableContainer: {
    width: "100%",
    height: "calc(100% - 50px)",
    paddingBottom: "20px",
    overflow: "auto",
  },
  container: {
    width: "100%",
    height: "100%",

  },
}));

const TableStraddle = ({ rowHover, DropDonwcolumns, pageType, middleStrike, data, tokensMap, source, prevData, inputValues, info, isQT, buySellClick, chartClick }) => {
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.basket.data);
  const [updateScroll, setUpdateScroll] = useState(false);

  const classes = useStyles();


  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <div className={classes.tableContainer}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow

            >
              <TableCell
                align="center"
                className={`${classes.colh}`}
                id="fno-table-header-cell"
              >
                {pageType == "strangle" ? "Strike" : "Strike Price"}
              </TableCell>

              {/* calls */}
              {DropDonwcolumns.filter((item) => item.accessorKey === "deltaCE" && item.enableColumn).length > 0 &&
                <TableCell
                  align="center"
                  className={`${classes.colh}`}
                  id="fno-table-header-cell"
                >
                  CE Delta
                </TableCell>
              }
              <TableCell
                align="center"
                className={`${classes.colh}`}
                id="fno-table-header-cell"
              >
                CE LTP
              </TableCell>





              {/* puts */}

              {pageType == "strangle" && <TableCell
                align="center"
                className={`${classes.colh}`}
                id="fno-table-header-cell"
              >
                Strike
              </TableCell>
              }



              <TableCell
                align="center"
                className={`${classes.colh}`}
                id="fno-table-header-cell"
              >
                PE LTP
              </TableCell>
              {DropDonwcolumns.filter((item) => item.accessorKey === "deltaPE" && item.enableColumn).length > 0 &&

                <TableCell
                  align="center"
                  className={`${classes.colh}`}
                  id="fno-table-header-cell"
                >
                  PE Delta
                </TableCell>
              }


              {/* straddle */}
              {/* 
                {pageType == "strangle"  && <TableCell
                  align="center"
                  style={{ width: "10%" }}
                  className={`row justify-content-md-center ${classes.headingCol} straddle-heading-second`}
                >
                  Strikes
                </TableCell>
               } */}

              <TableCell
                align="center"
                className={`${classes.colh}`}
                id="fno-table-header-cell"
              >
                Strangle LTP
              </TableCell>
              {DropDonwcolumns.filter((item) => item.accessorKey === "ivCE" && item.enableColumn).length > 0 &&

                <TableCell
                  align="center"
                  className={`${classes.colh}`}
                  id="fno-table-header-cell"
                >
                  CE IV
                </TableCell>
              }
              {DropDonwcolumns.filter((item) => item.accessorKey === "ivPE" && item.enableColumn).length > 0 &&
                <TableCell
                  align="center"
                  className={`${classes.colh}`}
                  id="fno-table-header-cell"
                >
                  PE IV
                </TableCell>
              }

            </TableRow>
          </TableHead>
          <TableBody>
            {!data || data.length === 0 ? (
              <TableEmptyState colSpan={12} />
            ) : (
              data.map((row) => (
                <DataTableRow
                  pageType={pageType}
                  middleStrike={middleStrike}
                  key={row.strike}
                  source={source}
                  rowData={row}
                  tokens={pageType === "strangle" ? {
                    "CE": tokensMap[row.strikeCE]?.CE,
                    "exchangeToken-CE": tokensMap[row.strikeCE]?.['exchangeToken-CE'],
                    "tradingSymbol-CE": tokensMap[row.strikeCE]?.['tradingSymbol-CE'],
                    "exchange-CE": tokensMap[row.strikeCE]?.['exchange-CE'],
                    "lotSize-CE": tokensMap[row.strikeCE]?.['lotSize-CE'],
                    "displayName-CE": tokensMap[row.strikeCE]?.['displayName-CE'],

                    "PE": tokensMap[row.strikePE]?.PE,
                    "exchangeToken-PE": tokensMap[row.strikePE]?.['exchangeToken-PE'],
                    "tradingSymbol-PE": tokensMap[row.strikePE]?.['tradingSymbol-PE'],
                    "exchange-PE": tokensMap[row.strikePE]?.['exchange-PE'],
                    "lotSize-PE": tokensMap[row.strikePE]?.['lotSize-PE'],
                    "displayName-PE": tokensMap[row.strikePE]?.['displayName-PE']
                  } : tokensMap[row.strike]}
                  prev={pageType === "strangle" ? { ce: prevData[row.strikeCE]?.ce, pe: prevData[row.strikePE]?.pe } : prevData[row.strike]}
                  buySellClick={buySellClick}
                  chartClick={chartClick}
                  rowHover={rowHover}
                  DropDonwcolumns={DropDonwcolumns}
                />
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default TableStraddle;
